export const SAUCE_OPTIONS = [
    {value: 'kiss', label: 'Kiss'},
    {value: 'ketchup', label: 'Ketchup'},
    {value: 'mayonnaise', label: 'Mayonnaise'},
    {value: 'gilles', label: 'Gilles (Barbecue & Samouraï)'}
];

export function formatSauce(value) {
    return SAUCE_OPTIONS.find(option => option.value === value)?.label || value;
}
